import React, { Component } from 'react';
import { connect } from 'react-redux';
import { CarService } from '../../service/CarService';
import { Button } from 'primereact/button';
import {Dropdown} from 'primereact/dropdown';
import { Chart } from 'primereact/chart';
import { FullCalendar } from 'primereact/fullcalendar';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import timeGridPlugin from '@fullcalendar/timegrid';
import { ScrollPanel } from 'primereact/scrollpanel';
// import FeatureVideo from '../../components/Dashboard/Widgets/FeatureVideo/FeatureVideo';
import NewsFeeds from '../../components/Dashboard/Widgets/NewsUpdates/NewsUpdates';
import RequestLeave from '../../components/Dashboard/Widgets/Request/Request';
import OperationRequest from '../../components/Dashboard/Widgets/OperationRequest/OperationRequest';
import Recruitment from '../../components/Dashboard/Widgets/Recruitment/Recruitment';
import Teams from '../../components/Dashboard/Widgets/MyTeam/MyTeam';
import Holidays from '../../components/Dashboard/Widgets/Holidays/Holidays';
import ChangePassword from '../../components/Dashboard/ChangePassword';
import { Toast } from 'primereact/toast';
import Messages from '../../shared/UI/Messages/Messages';
import * as actions from '../../store/actions/index';
import { MYTEAM_SUBMENU_ID, VIDEO_SUBMENU_ID, NEWS_DASHBOARD_SUBMENU_ID, HOLIDAY_DASHBOARD_SUBMENU_ID, MYLEAVEBAL_SUBMENU_ID, REQSTATISTICS_SUBMENU_ID, LEAVE_REQUEST_ID, ADDITIONAL_LEAVE_QUOTA_ID, WORK_SCHEDULE_ID, VACATION_PLAN_ID, OVERTIME_PREAPPROVAL_ID, BREAK_PERMISSION_ID, LEAVE_CANCELLATION_ID, PAYROLL_REPORT_ID, FLEXIBLE_TIMING_ID, TIMESHEET_ID, EVENT_MANAGEMENT_ID,COSTCENTER_ID,EMPLOYEE_LOAN_ID,DAILY_ACTIVITY_ID,WORK_SCHEDULE_SINGLE_ID,REQUEST_FOR_QUOTATION_ID,OPENING_STOCK_ID,PHYSICAL_STOCK_ID,SUPPLIER_QUOTATION_ID,MATERIAL_REQUIREMENT_PLANNING_ID,PURCHASE_REQUISITION_ID,JOURNAL_VOUCHER_ID,SALES_ORDER_ID,PRODUCTION_PLANNING_ID,MENU_FORECAST_ID,WASTAGE_ID,GRN_ID,PURCHASE_RETURN_ID,PURCHASE_ORDER_ID,IMPREST_SYSTEM_ID,CAMPAIGN_ID,STOCK_ADJUSTMENT_ID,TABLE_RESERVATION_PROCESS_ID,CASH_RECEIPT_ID,BANK_RECEIPT_ID,PURCHASE_INVOICE_ID,
 JOB_REQUISITIONS_ID, SHORT_LISTING_ID, JOB_INTERVIEW_ID, RANKING_PROCESS_ID, JOINING_PROCESS_ID, JOB_APPLICATION_ID,RECRUITMENT_SUBMENU_ID, TRAVEL_AUTHORIZATION_ID, BUSINESS_TRIP_ID,GATEPASS_VISITOR_ID,MATERIAL_PASS_IN_ID,MATERIAL_PASS_OUT_ID,MATERIAL_PASS_VEHICLE_ID, WORK_PERMIT_ID, WCA_INBOX_SUBMENU_ID, ATTENDANCECHART_SUBMENU_ID, PROCESS_INCIDENT_REPORT_ID, CALENDAR_SUBMENU_ID, WCA_STATISTICS_SUBMENU_ID, SAFETY_CONTROLLER_LIST_SUBMENU_ID, ACCEPTOR_LIST_SUBMENU_ID, SIMULATION_ID, HEADCOUNT_CHART_ID, MOC_ID,TMOC_ID,SERVICE_ID, LEAVE_HEADCOUNT_CHART_ID,MONTHLY_EVALUATION_ID,HDS_INCIDENT_ID,HDS_PROBLEM_ID,HDS_CHANGE_ID,KPI_TARGET_ID,FI_INVOICE_ID,KPI_ACTUAL_ID,HR_ANALYTICS,OM_ANALYTICS,AdvanceRequest_ID,TIMEBOOKING_ID,MOBLIZATION_ID,DEMOBLIZATION_ID,VENDORREGISTRATION_ID} from '../../shared/Config';
import { HASACCESS, ENCRYPT } from '../../shared/utility';
import axios from '../../axios-url';
import moment from 'moment';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Card } from 'primereact/card';
import { Dialog } from 'primereact/dialog';
import {InputText} from 'primereact/inputtext';
import { Checkbox } from 'primereact/checkbox';
import { DROPDOWN_CONFIG} from '../../shared/Config';
/* 
Explanation for reference codes
###DS*01 : this is to make all fields disabled when viewing Work Permits through the request invovled tab of operation inbox 
*/

class Dashboard extends Component {

    calendarRef = React.createRef()
    constructor() {
        super();
        this.state = {
            approveRejectDisabled: false,
            showteamMembers:false,
            //search fields for HR Inbox
            globalFilterY: null ,
            globalFilterP: null ,
            globalFilterA: null ,
            globalFilterR: null ,
            //search fields for Operation Inbox
            onHCChanged: null,
            onHPChanged: null,
            onHAChanged: null,
            onHIChanged: null,
            onHRSChanged: null,
            onHRChanged: null,
            onHRRChanged: null,
            onHReChanged: null,
            onHRFCSChanged: null,
            onHCaChanged: null,
            onHPlChanged: null,
            onHRRIChanged: null,
            checked:false,
            options: {
                plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
                defaultView: 'dayGridMonth',
                defaultDate: new Date(),
                header: {
                    left: 'prev,next',
                    center: 'title',
                    right: 'dayGridMonth,timeGridWeek,timeGridDay'
                },
                editable: false,
                draggable: false,
                weekends: true,
                // dateClick: (e) => {
                //     this.props.history.push({pathname: '/break-permission-process-request', state: {attendanceDate: e.date} })
                // },
                datesRender: function ({ view }) {
                    const currentRange = view.props && view.props.dateProfile && view.props.dateProfile.currentRange;

                    this.setState({ currentRange });

                    this.props.getCalendarData(this.state.viewCalendarFor, 'Dashboard', moment(currentRange.start).format('MM-DD-YYYY'), moment(currentRange.end).format('MM-DD-YYYY'));
                }.bind(this)

            } ,
            tasks: [],
            city: null,
            selectedCar: null,
            fullcalendarOptions: {
                plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
                defaultDate: '2017-02-01',
                header: {
                    left: 'prev,next today',
                    center: 'title',
                    right: 'month,agendaWeek,agendaDay'
                },
                editable: true
            },
            events: [
                {
                    "id": 1,
                    "title": "All Day Event",
                    "start": "2017-02-01"
                },
                {
                    "id": 2,
                    "title": "Long Event",
                    "start": "2017-02-07",
                    "end": "2017-02-10"
                },
                {
                    "id": 3,
                    "title": "Repeating Event",
                    "start": "2017-02-09T16:00:00"
                },
                {
                    "id": 4,
                    "title": "Repeating Event",
                    "start": "2017-02-16T16:00:00"
                },
                {
                    "id": 5,
                    "title": "Conference",
                    "start": "2017-02-11",
                    "end": "2017-02-13"
                },
                {
                    "id": 6,
                    "title": "Meeting",
                    "start": "2017-02-12T10:30:00",
                    "end": "2017-02-12T12:30:00"
                },
                {
                    "id": 7,
                    "title": "Lunch",
                    "start": "2017-02-12T12:00:00"
                },
                {
                    "id": 8,
                    "title": "Meeting",
                    "start": "2017-02-12T14:30:00"
                },
                {
                    "id": 9,
                    "title": "Happy Hour",
                    "start": "2017-02-12T17:30:00"
                },
                {
                    "id": 10,
                    "title": "Dinner",
                    "start": "2017-02-12T20:00:00"
                },
                {
                    "id": 11,
                    "title": "Birthday Party",
                    "start": "2017-02-13T07:00:00"
                },
                {
                    "id": 12,
                    "title": "Click for Google",
                    "url": "http://google.com/",
                    "start": "2017-02-28"
                }
            ],
            activeIndex: 0,
            barData: {
                labels: ['Allocated Leave', 'Balanced Leave'],
                datasets: [
                    {
                        label: 'Allocated Leave',
                        backgroundColor: '#03A9F4',
                        borderColor: '#03A9F4',
                        data: [30, 5, 1, 8]
                    },
                    {
                        label: 'Balanced Leave',
                        backgroundColor: '#FFC107',
                        borderColor: '#FFC107',
                        data: [28, 6, 0, 4]
                    }
                ]
            },
            passwordPopUp: false,
            password: '',
            confirmPassword: '',
            selectedApproval: [],
            loading: false,
            hCEmpDislay: false,
            detailedHCData: [],
            hCTableData:[],
            hCTableFilter: null,
            jobreqd:null,
            HCText: "",
            passwordchangesuccess: false,
        };

        this.onTaskChange = this.onTaskChange.bind(this);
        this.onCityChange = this.onCityChange.bind(this);
        this.carservice = new CarService();
        this.exportCSV = this.exportCSV.bind(this);
    }

    onTaskChange(e) {
        let selectedTasks = [...this.state.tasks];
        if (e.checked)
            selectedTasks.push(e.value);
        else
            selectedTasks.splice(selectedTasks.indexOf(e.value), 1);

        this.setState({ tasks: selectedTasks });
    }

    myCalendar(){
        const currentRange = this.state.currentRange || false;
            this.props.getCalendarData(this.props.loggedUserDetail.empID, 'Dashboard', moment(currentRange && currentRange.start || '').format('MM-DD-YYYY'), moment(currentRange && currentRange.end || '').format('MM-DD-YYYY'));
        }


    onCityChange(e) {
        this.setState({ city: e.value });
    }

    componentDidMount() {
        this.props.getRequest();
        this.props.getCalendarData();
        this.props.getMasterTableList('GetWPCertificate'); 

        // let startDate = moment().startOf('month').format('MM-DD-YYYY');
        // let endDate = moment().endOf('month').format('MM-DD-YYYY');
        // this.getCalendarEvents(this.props.loggedUserDetail.empID, 'Dashboard', startDate, endDate);
        // this.getCalendarEvents(this.props.loggedUserDetail.empID, 'Dashboard', moment(this.state.currentRange.start).format('MM-DD-YYYY'), moment(this.state.currentRange.end).format('MM-DD-YYYY'))
        this.setState({loading: true})
        setTimeout(() =>{
            // if(this.props.requestListData[4] !== undefined){
            //     if(this.props.requestListData[4].length > 0){
            //         this.setState({showteamMembers: true})
            //     }
            // }
            if (this.state.viewCalendarFor== undefined){
            this.setState({viewCalendarFor:this.props.loggedUserDetail.empID});
            }
           
        }, 5000)
        let menuData = localStorage.getItem('menuStorage_GetAuthorization');
        if (menuData == null) {
            setTimeout(() => { }, 4000)
        }

        setTimeout(() => {
            this.setState({loading: true});
            this.getTeamAccess = HASACCESS(MYTEAM_SUBMENU_ID);
            this.getVideoAccess = HASACCESS(VIDEO_SUBMENU_ID);
            this.getNewsAccess = HASACCESS(NEWS_DASHBOARD_SUBMENU_ID);
            this.getHolidayAccess = HASACCESS(HOLIDAY_DASHBOARD_SUBMENU_ID);
            this.getLeaveChartAccess = HASACCESS(MYLEAVEBAL_SUBMENU_ID);
            this.getRequestsAccess = HASACCESS(REQSTATISTICS_SUBMENU_ID);
            this.getRecruitmentAccess = HASACCESS(RECRUITMENT_SUBMENU_ID);
            this.getOperationRequestsAccess = HASACCESS(WCA_INBOX_SUBMENU_ID);
            this.getAttendanceChartAccess = HASACCESS(ATTENDANCECHART_SUBMENU_ID);
            this.getCalendarAccess = HASACCESS(CALENDAR_SUBMENU_ID);
            this.getWcaStatisticsAccess = HASACCESS(WCA_STATISTICS_SUBMENU_ID);
            this.getSafetyControllerListAccess = HASACCESS(SAFETY_CONTROLLER_LIST_SUBMENU_ID);
            this.getAcceptorListAccess = HASACCESS(ACCEPTOR_LIST_SUBMENU_ID);
            this.getHeadCountChrtAccess =  HASACCESS(HEADCOUNT_CHART_ID);
            this.getLeaveHeadCountChrtAccess =  HASACCESS(LEAVE_HEADCOUNT_CHART_ID);            
            
            this.setState({loading: false});
        },1500)

        let isAutoRefreshEnabled = localStorage.getItem("autoRefresh")
        if(isAutoRefreshEnabled == 'true'){
            this.setState({checked:true});
            this.autoRefreshInterval = setInterval(this.pageReload, 120000); // <- time in ms
        }
        


        this.carservice.getCarsLarge().then(data => this.setState({ cars: data }));

        // this.props.getMasterTableList('Company/GetCompany');

        let firstTimeLogin = localStorage.getItem('firstTimeLogin')
        if (firstTimeLogin === "True") {
            this.setState({ passwordPopUp: true });
        }
        
    }

    componentWillUnmount() {
        clearInterval(this.autoRefreshInterval);
      }

    getHeadCountData = () => {
        axios.get(`/master/api/Request/GetRequest?id=${this.props.loginUserDetail.employeeId}&type=HeadCount`)
            .then(response => {
                if (response.status === 200) {
                    let hCEType = this.state.HCEType;
                    let data = response.data[1];
                    let tableData = data.filter(el => el.location == hCEType)
                    this.setState({hCEmpDislay:true, loading:false,HCEType:'',hCTableData: tableData});
                    return 
                }
            })
            .catch(err => {
                this.growl.show({ severity: 'error', summary: null, detail: 'Head Count Fetch Failed' });
                this.setState({loading:false, HCEType:''});
            })
    }

    change = (e) => {
        let { name, value } = e.target;
        this.setState({ [name]: value });
    }

    clearPassword = () => {
        this.setState({ passwordPopUp: false, password: '', confirmPassword: '' });
    }

    changePassword = () => {

        if (this.state.password === '') {
            this.growl.show({ severity: 'error', summary: null, detail: 'Password is required' });
            return;
        } else if (this.state.password.length < 6) {
            this.growl.show({ severity: 'error', summary: null, detail: 'Password should be 6 digits minimum' });
            return;
        } else if (this.state.confirmPassword === '') {
            this.growl.show({ severity: 'error', summary: null, detail: 'Confirm password is required' });
            return;
        } else if (this.state.password !== this.state.confirmPassword) {
            this.growl.show({ severity: 'error', summary: null, detail: 'Password should be match with Confirm password' });
            return;
        }

        let data = {
            UserID: this.props.loginUserDetail.userId,
            password: this.state.password
        }
      
        this.props.processDynamicData('PasswordChange', 'edit', data, 'Employee/GetEmployeeGroups');

        setTimeout(() => {
            if (this.props.success !== null) {
                localStorage.setItem('firstTimeLogin', 1)
                this.setState({ passwordPopUp: false })
                this.setState({ passwordchangesuccess: true })
            }
        }, 1000)

    }
    activeTab = (index) => {
        this.setState({ activeIndex: index });
    }

    requestRedirect = (rowData, type) => {
        let url = '';

        if (type !== 'Action Request') {
            if (rowData.processId.toUpperCase() === LEAVE_REQUEST_ID.toUpperCase()) {
                url = '/leave-request/edit/'
            } else if (rowData.processId.toUpperCase() === ADDITIONAL_LEAVE_QUOTA_ID.toUpperCase()) {
                url = '/additional-leave-quota/edit/'
            } else if (rowData.processId.toUpperCase() === WORK_SCHEDULE_ID.toUpperCase()) {
                url = '/shift-approval/edit/'
            } else if (rowData.processId.toUpperCase() === WORK_SCHEDULE_SINGLE_ID.toUpperCase()) {
                url = '/shift-approval-single/edit/'
            } else if (rowData.processId.toUpperCase() === VACATION_PLAN_ID.toUpperCase()) {
                url = '/vacation-request/edit/'
            } else if (rowData.processId.toUpperCase() === OVERTIME_PREAPPROVAL_ID.toUpperCase()) {
                url = '/overtime-pre-approval-form/edit/'
            } else if (rowData.processId.toUpperCase() === BREAK_PERMISSION_ID.toUpperCase()) {
                url = '/break-permission-process-request/edit/'
            } else if (rowData.processId.toUpperCase() === LEAVE_CANCELLATION_ID.toUpperCase()) {
                url = '/leave-cancellation-request/edit/'
            } else if (rowData.processId.toUpperCase() === PAYROLL_REPORT_ID.toUpperCase()) {
                url = '/add-payroll-report/edit/'
            } else if (rowData.processId.toUpperCase() === FLEXIBLE_TIMING_ID.toUpperCase()) {
                url = '/flexible-timing-request/edit/'
            } else if(rowData.processId.toUpperCase() === TIMESHEET_ID.toUpperCase()) {
                url = '/add-timesheet-process/edit/'
            } else if(rowData.processId.toUpperCase() === JOB_REQUISITIONS_ID.toUpperCase()) {
                url = '/add-job-requistions/edit/'
            } else if(rowData.processId.toUpperCase() === SHORT_LISTING_ID.toUpperCase()) {
                url = '/add-shortlisting/edit/'
            } else if(rowData.processId.toUpperCase() === JOB_INTERVIEW_ID.toUpperCase()) {
                url = '/add-interview/edit/'
            } else if(rowData.processId.toUpperCase() === RANKING_PROCESS_ID.toUpperCase()) {
                url = '/add-ranking-process/edit/'
            } else if(rowData.processId.toUpperCase() === JOINING_PROCESS_ID.toUpperCase()) {
                url = '/add-joining-process/edit/'
            } else if(rowData.processId.toUpperCase() === JOB_APPLICATION_ID.toUpperCase()) {
                url = '/add-job-application/edit/'
            } else if(rowData.processId.toUpperCase() === TRAVEL_AUTHORIZATION_ID.toUpperCase()) {
                url = '/add-travel-authorization/edit/'
            } else if(rowData.processId.toUpperCase() === BUSINESS_TRIP_ID.toUpperCase()) {
                url = '/add-business-trip/edit/'
            } else if(rowData.processId.toUpperCase() === GATEPASS_VISITOR_ID.toUpperCase()) {
                url = '/Add-Visitor-Gatepass/edit/'
            } else if(rowData.processId.toUpperCase() === MATERIAL_PASS_IN_ID.toUpperCase()) {
                url = '/Add-MaterialPass-In/edit/'
            } else if(rowData.processId.toUpperCase() === MATERIAL_PASS_OUT_ID.toUpperCase()) {
                url = '/Add-MaterialPass-Out/edit/'
            } else if(rowData.processId.toUpperCase() === MATERIAL_PASS_VEHICLE_ID.toUpperCase()) {
                url = '/Add-MaterialPass-Vehicle/edit/'
            } else if(rowData.processId.toUpperCase() === WORK_PERMIT_ID.toUpperCase()) {
                url = '/Add-WorkPermit/edit/'
            } else if(rowData.processId.toUpperCase() === PROCESS_INCIDENT_REPORT_ID.toUpperCase()) {
                url = '/Add-Process-Incident-Report/edit/'
            } else if(rowData.processId.toUpperCase() === SIMULATION_ID.toUpperCase()) {
                url = '/Add-Simulation/edit/'
            } else if(rowData.processId.toUpperCase() === MOC_ID.toUpperCase()) {
                url = '/Add-Plant-Modification/edit/'
            } else if(rowData.processId.toUpperCase() === TMOC_ID.toUpperCase()) {
                url = '/Add-Temporary-Plant-Modification/edit/' 
            } else if(rowData.processId.toUpperCase() === SERVICE_ID.toUpperCase()) {
                url = '/Add-Service/edit/'                                
            } 
            else if(rowData.processId.toUpperCase() ===  MONTHLY_EVALUATION_ID.toUpperCase()) {
                url = '/Add-Monthly-Evaluation/edit/'  
            }
            else if(rowData.processId.toUpperCase() ===  HDS_INCIDENT_ID.toUpperCase()) {
                url = '/Add-ITSMIncident/edit/'  
            }
            else if(rowData.processId.toUpperCase() ===  HDS_PROBLEM_ID.toUpperCase()) {
                url = '/Add-ITSMProblem/edit/'  
            }
            else if(rowData.processId.toUpperCase() ===  HDS_CHANGE_ID.toUpperCase()) {
                url = '/Add-ITSMChange/edit/'  
            }  
            else if(rowData.processId.toUpperCase() ===  KPI_TARGET_ID.toUpperCase()) {
                url = '/Add-KPITarget/edit/'  
            }  
            else if(rowData.processId.toUpperCase() ===  KPI_ACTUAL_ID.toUpperCase()) {
                url = '/Add-KPIActual/edit/'  
            }                                               
            else if(rowData.processId.toUpperCase() ===  FI_INVOICE_ID.toUpperCase()) {
                url = '/Add-RecInvoice/edit/'  
            }   
            else if(rowData.processId.toUpperCase() ===  AdvanceRequest_ID.toUpperCase()) {
                url = '/Add-Advance/edit/'  
            }  
            else if(rowData.processId.toUpperCase() ===  MOBLIZATION_ID.toUpperCase()) {
                url = '/Add-Moblization/edit/'  
            } 
            else if(rowData.processId.toUpperCase() ===  TIMEBOOKING_ID.toUpperCase()) {
                url = '/Add-TimeBooking/edit/'  
            } 
            else if(rowData.processId.toUpperCase() ===  DEMOBLIZATION_ID.toUpperCase()) {
                url = '/Add-DeMoblization/edit/'  
            } 
            else if(rowData.processId.toUpperCase() ===  VENDORREGISTRATION_ID.toUpperCase()) {
                url = '/Add-VendorRegistration/edit/'  
            } 
            else if(rowData.processId.toUpperCase() ===  EVENT_MANAGEMENT_ID.toUpperCase()) {
                url = '/Add-event-management/edit/'  
            } 
            else if(rowData.processId.toUpperCase() ===  COSTCENTER_ID.toUpperCase()) {
                url = '/CostCenter/edit/'  
            } 
            else if(rowData.processId.toUpperCase() ===  EMPLOYEE_LOAN_ID.toUpperCase()) {
                url = '/EmployeeLoan/edit/'  
            } 
            else if(rowData.processId.toUpperCase() ===  DAILY_ACTIVITY_ID.toUpperCase()) {
                url = '/DailyActivity/edit/'  
            } 
            else if(rowData.processId.toUpperCase() ===  REQUEST_FOR_QUOTATION_ID.toUpperCase()) {
                url = '/add-requestforquotation/edit/'  
            } 
            else if(rowData.processId.toUpperCase() ===  OPENING_STOCK_ID.toUpperCase()) {
                url = '/add-openingstock/edit/'  
            } 

             else if(rowData.processId.toUpperCase() ===  PHYSICAL_STOCK_ID.toUpperCase()) {
                url = '/add-physicalstock/edit/'  
            } 
             else if(rowData.processId.toUpperCase() ===  SUPPLIER_QUOTATION_ID.toUpperCase()) {
                url = '/add-supplierquotation/edit/'  
            } 

             else if(rowData.processId.toUpperCase() ===  MATERIAL_REQUIREMENT_PLANNING_ID.toUpperCase()) {
                url = '/add-materialrequirementplanning/edit/'  
            } 
             else if(rowData.processId.toUpperCase() ===  PURCHASE_REQUISITION_ID.toUpperCase()) {
                url = '/add-purchaserequisition/edit/'  
            } 
             else if(rowData.processId.toUpperCase() ===  JOURNAL_VOUCHER_ID.toUpperCase()) {
                url = '/add-journalvoucher/edit/'  
            } 
             else if(rowData.processId.toUpperCase() ===  SALES_ORDER_ID.toUpperCase()) {
                url = '/add-salesorder/edit/'  
            } 

              else if(rowData.processId.toUpperCase() ===  PRODUCTION_PLANNING_ID.toUpperCase()) {
                url = '/add-productionplanning/edit/'  
            } 

              else if(rowData.processId.toUpperCase() ===  MENU_FORECAST_ID.toUpperCase()) {
                url = '/add-menuforecast/edit/'  
            } 

              else if(rowData.processId.toUpperCase() ===  WASTAGE_ID.toUpperCase()) {
                url = '/add-wastage/edit/'  
            } 

              else if(rowData.processId.toUpperCase() ===  GRN_ID.toUpperCase()) {
                url = '/add-goodsreceiptnote/edit/'  
            } 

              else if(rowData.processId.toUpperCase() ===  PURCHASE_RETURN_ID.toUpperCase()) {
                url = '/add-purchase-return/edit/'  
            } 
              else if(rowData.processId.toUpperCase() ===  PURCHASE_ORDER_ID.toUpperCase()) {
                url = '/add-purchase-order/edit/'  
            } 
              else if(rowData.processId.toUpperCase() ===  IMPREST_SYSTEM_ID.toUpperCase()) {
                url = '/add-ImprestSystem/edit/'  
            } 
              else if(rowData.processId.toUpperCase() ===  CAMPAIGN_ID.toUpperCase()) {
                url = '/add-marketingcampaign/edit/'  
            } 
              else if(rowData.processId.toUpperCase() ===  STOCK_ADJUSTMENT_ID.toUpperCase()) {
                url = '/add-stockadjustment/edit/'  
            } 
              else if(rowData.processId.toUpperCase() ===  TABLE_RESERVATION_PROCESS_ID.toUpperCase()) {
                url = '/pos/add-tablereservation/edit/'  
            } 
              else if(rowData.processId.toUpperCase() ===  CASH_RECEIPT_ID.toUpperCase()) {
                url = '/add-cashreceipt/edit/'  
            } 
              else if(rowData.processId.toUpperCase() ===  BANK_RECEIPT_ID.toUpperCase()) {
                url = '/add-bankreceipt/edit/'  
            } 
              else if(rowData.processId.toUpperCase() ===  PURCHASE_INVOICE_ID.toUpperCase()) {
                url = '/add-purchaseinvoice/edit/'  
            } 
        }

        

        if (rowData.requestId !== undefined || rowData.requestid !== undefined) {
            if (type === 'Your Request') {
                if (url.indexOf('flexible-timing-request') > -1 || url.indexOf('add-payroll-report') > -1 || url.indexOf('shift-approval') > -1 || url.indexOf('shift-approval-single') > -1 || url.indexOf('vacation-request') > -1 || url.indexOf('overtime-pre-approval-form') > -1 || url.indexOf('break-permission') > -1 || url.indexOf('leave-cancellation') > -1 || url.indexOf('timesheet') > -1 || url.indexOf('job-requistions') > -1 || url.indexOf('shortlisting') > -1 || url.indexOf('interview') > -1 || url.indexOf('ranking-process') > -1 || url.indexOf('joining-process') > -1 || url.indexOf('job-application') > -1 || url.indexOf('travel-authorization') > -1 || url.indexOf('business-trip') > -1 || url.indexOf('/Add-Visitor-Gatepass') > -1 || url.indexOf('/Add-MaterialPass-In') > -1 || url.indexOf('/Add-MaterialPass-Out') > -1 || url.indexOf('/Add-MaterialPass-Vehicle') > -1 || url.indexOf('/Add-WorkPermit') > -1 || url.indexOf('/Add-Process-Incident-Report') > -1 || url.indexOf('/Add-Simulation') > -1 || url.indexOf('/Add-Plant-Modification') > -1 || url.indexOf('/Add-Service') > -1 || url.indexOf('/Add-ITSMIncident') > -1 || url.indexOf('/Add-ITSMProblem') > -1 || url.indexOf('/Add-ITSMChange') > -1 || url.indexOf('/Add-KPITarget') > -1 || url.indexOf('/Add-KPIActual') > -1 || url.indexOf('/Add-RecInvoice') > -1 || url.indexOf('/Add-Advance') > -1 || url.indexOf('/Add-event-management') > -1 || url.indexOf('CostCenter') > -1 || url.indexOf('EmployeeLoan') > -1 || url.indexOf('DailyActivity') > -1 ) {
                    this.props.history.push({
                        pathname: `${url}${rowData.requestId}`, state: {
                            ...rowData, editStatus: 'Closed'
                        }
                    });
                }
                else if (url.indexOf('leave-request') > -1 || url.indexOf('additional-leave-quota') > -1) {
                    let workflowId = ENCRYPT(rowData.request_WF_LEVEL_ID);
                    this.props.history.push(url + rowData.requestId + '?sno=' + ENCRYPT(rowData.stagesequence) + '&levelid=' + workflowId,{
                        state: { editStatus: 'Closed' } });
                    // this.props.history.push({
                    //              state: { editStatus: 'Closed'
                    //     }
                    // });
                }
                else {
                    this.props.history.push(url + rowData.requestId)
                }

            }  else if (url.indexOf('leave-request') > -1 || url.indexOf('additional-leave-quota') > -1)
                {
    
                            if (type === 'Pending Request') {
                                let workflowId = ENCRYPT(rowData.request_WF_LEVEL_ID);
                                this.props.history.push(url + rowData.requestId + '?sno=' + ENCRYPT(rowData.stagesequence) + '&levelid=' + workflowId,{
                                    state: { editStatus: 'Open' } });
                            }
                            else {
                                let workflowId = ENCRYPT(rowData.request_WF_LEVEL_ID);
                                this.props.history.push(url + rowData.requestId + '?sno=' + ENCRYPT(rowData.stagesequence) + '&levelid=' + workflowId,{
                                    state: { editStatus: 'Closed' } });
                                
                            }
                       
                // else {
                //             this.props.history.push({ pathname: url + rowData.requestId + '?sno=' + ENCRYPT(rowData.stagesequence), state: { request_WF_LEVEL_ID: rowData.request_WF_LEVEL_ID } });
                //         }
                 
                }
            else if ((type === 'Pending Request' || type === 'Request Involved') && (url.indexOf('flexible-timing-request') > -1 || url.indexOf('add-payroll-report') > -1 || url.indexOf('shift-approval') > -1 || url.indexOf('shift-approval-single') > -1  || url.indexOf('vacation-request') > -1 || url.indexOf('overtime-pre-approval-form') > -1 || url.indexOf('break-permission') > -1 || url.indexOf('leave-cancellation') > -1 || url.indexOf('timesheet') > -1 || url.indexOf('job-requistions') > -1 || url.indexOf('shortlisting') > -1 || url.indexOf('interview') > -1 || url.indexOf('ranking-process') > -1 || url.indexOf('joining-process') > -1 || url.indexOf('job-application') > -1 || url.indexOf('travel-authorization') > -1 || url.indexOf('business-trip') > -1 || url.indexOf('/Add-Visitor-Gatepass') > -1 || url.indexOf('/Add-MaterialPass-In') > -1 || url.indexOf('/Add-MaterialPass-Out') > -1 || url.indexOf('/Add-MaterialPass-Vehicle') > -1 || url.indexOf('/Add-WorkPermit') > -1 || url.indexOf('/Add-Process-Incident-Report' > -1 || url.indexOf('/Add-Simulation') > -1) || url.indexOf('/Add-Plant-Modification') > -1 || url.indexOf('/Add-Service') > -1 || url.indexOf('/Add-ITSMIncident') > -1 || url.indexOf('/Add-ITSMProblem') > -1 || url.indexOf('/Add-ITSMChange') > -1 || url.indexOf('/Add-KPITarget') > -1 || url.indexOf('/Add-KPIActual') > -1 || url.indexOf('Add-RecInvoice') > -1 || url.indexOf('Add-Advance') > -1 || url.indexOf('Add-event-management') > -1|| url.indexOf('CostCenter') > -1|| url.indexOf('EmployeeLoan') > -1 || url.indexOf('DailyActivity') > -1 ))
            {
                // if (url.indexOf('flexible-timing-request') > -1 || url.indexOf('add-payroll-report') > -1 || url.indexOf('shift-approval') > -1 || url.indexOf('vacation-request') > -1 || url.indexOf('overtime-pre-approval-form') > -1 || url.indexOf('break-permission') > -1 || url.indexOf('leave-cancellation') > -1 || url.indexOf('timesheet') > -1 || url.indexOf('job-requistions') > -1 || url.indexOf('shortlisting') > -1 || url.indexOf('interview') > -1 || url.indexOf('ranking-process') > -1 || url.indexOf('joining-process') > -1 || url.indexOf('job-application') > -1 || url.indexOf('travel-authorization') > -1 || url.indexOf('business-trip') > -1 || url.indexOf('/Add-Visitor-Gatepass') > -1 || url.indexOf('/Add-MaterialPass-In') > -1 || url.indexOf('/Add-MaterialPass-Out') > -1 || url.indexOf('/Add-MaterialPass-Vehicle') > -1 || url.indexOf('/Add-WorkPermit') > -1 || url.indexOf('/Add-Process-Incident-Report' > -1 || url.indexOf('/Add-Simulation') > -1) || url.indexOf('/Add-Plant-Modification') > -1 || url.indexOf('/Add-Service') > -1 || url.indexOf('/Add-ITSMIncident') > -1 || url.indexOf('/Add-ITSMProblem') > -1 || url.indexOf('/Add-ITSMChange') > -1 || url.indexOf('/Add-KPITarget') > -1 || url.indexOf('/Add-KPIActual') > -1 || url.indexOf('Add-RecInvoice') > -1 || url.indexOf('Add-Advance') > -1)
                // {
                    


                this.props.history.push({
                    pathname: `${url}${rowData.requestId}`, state: Object.assign({}, { ...rowData }, { editStatus: 'Pending' })
                });
                // }
            }
             else if (type === 'Action Request') {
                let actionType = ENCRYPT(rowData.keyworD_TEXT);
                let stagesequence = ENCRYPT(3);
                let requestactionid = ENCRYPT(rowData.requestactionid);
                // url = '/leave-request/edit/'
                // this.props.history.push(url + rowData.requestid + '?sno=' + stagesequence + '&type=' + actionType + '&id=' + requestactionid) ***
                url = rowData.actiontype === 5 ? `/add-interview/edit/` : '/leave-request/edit/';
                const redirectUrl = {
                   pathname: rowData.actiontype === 5 ? (url + rowData.requestid) : (url + rowData.requestid + '&apr=false&sno='  + stagesequence + '&type=' + actionType + '&Actionid=' + requestactionid),
                    state: Object.assign({}, { ...rowData}, { editStatus: 'pendingAction'})};

                this.props.history.push(redirectUrl);
            } else if(type === 'WPRequest Involved'){//###DS*01 
                if ( url.indexOf('/Add-WorkPermit') > -1 ){
                    this.props.history.push({
                        pathname: `${url}${rowData.requestId}`, state: Object.assign({}, {...rowData}, { editStatus: 'Pending', fromRequestInvolved: true})
                    });
                }
            }
        }
    }

    handleApprove(type) {
        const { selectedApproval = [] } = this.state;
        // Disable Approve/Reject buttons immediately
        this.setState({ loading: true, approveRejectDisabled: true });
        if (type === 'approve' && selectedApproval.length > 0) {
            const submitData = Object.assign({}, {
                key: JSON.stringify({"CollectiveApproval":selectedApproval.reduce((a, el) => {
                    const data = Object.assign({}, {
                        RequestId: el.requestId,
                        EmployeeId: this.props.loggedUserDetail.empID,
                        Request_Wf_Level_Id: el,
                        SequenceNo: el.stagesequence,
                        CompanyId: el.companyId,
                        RequesterId: el.empId,
                        RequestedFor: el.requestedFor,
                        stageNum: el.stageNum
                    });
                    a.push(data);
                    return a;
                }, [])})
            });
            axios.post(`master/api/workflow/CollectiveApproval?model=test`, submitData)
                .then(response => {
                    this.setState({ loading: false });
                    this.growl.show({ severity: 'success', summary: null, detail: response.data.message });
                    setTimeout(()=> window.location.reload(), 1000);
                }).catch(err => {
                    this.setState({ loading: false, approveRejectDisabled: false });
                    this.growl.show({ severity: 'error', summary: null, detail: 'Approval api Failed' });
                })
        } else if (type === 'reject' && selectedApproval.length > 0) {
            const submitData = Object.assign({}, {
                key: JSON.stringify({"CollectiveReject":selectedApproval.reduce((a, el) => {
                    const data = Object.assign({}, {
                        RequestId: el.requestId,
                        EmployeeId: this.props.loggedUserDetail.empID,
                        Request_Wf_Level_Id: el.request_WF_LEVEL_ID,
                        SequenceNo: el.stagesequence,
                        CompanyId: el.companyId,
                        RequesterId: el.empId,
                        RequestedFor: el.requestedFor,
                        stageNum: el.stageNum
                    });
                    a.push(data);
                    return a;
                }, [])})
            });
            axios.post('master/api/workflow/CollectiveReject?model=test', submitData)
                .then(response => {
                    this.setState({ loading: false });
                    this.growl.show({ severity: 'success', summary: null, detail: response.data.message });
                    setTimeout(()=> window.location.reload(), 1000);
                }).catch(err => {
                    this.setState({ loading: false, approveRejectDisabled: false });
                    this.growl.show({ severity: 'error', summary: null, detail: 'Reject api Failed' });
                })
        } else {
            this.setState({ loading: false, approveRejectDisabled: false });
            this.growl.show({ severity: 'error', summary: null, detail: 'Please select data' });
        }
    }

    handleCalendarChange = (event) => {
        let selectedMember = event.target.value;
        const {currentRange} = this.state;
        this.setState({viewCalendarFor:selectedMember});
        this.props.getCalendarData(selectedMember, 'Dashboard', moment(currentRange && currentRange.start || '').format('MM-DD-YYYY'), moment(currentRange && currentRange.end || '').format('MM-DD-YYYY'));
    }

    headCountFooter = (type) => {
            return <div className="p-col-12">
                <Button label="Show List"  onClick={() => {
                this.setState({ HCEType:type, loading:true,HCText:"Head Count List" })
                this.getHeadCountData();
            }}
                style={{backgroundColor:'#406882'}} 
                />
            </div>
        };    

    LeaveheadCountFooter = (type) => {
        return <div className="p-col-12">
            <Button label="Show List"  onClick={() => {
            this.setState({ HCEType:type, loading:true ,HCText:"Leave Count List" })
            this.getHeadCountData();
        }}
            style={{backgroundColor:'#406882'}} 
            />
        </div>
    };           

    // to download list of employees in assembly point
    exportCSV() {
        this.setState({loading:true});
        this.dt.exportCSV();
        this.setState({loading:false});
    }

    pageReload(){
        window.location.reload(false);
    }

    handleAutoRefresh(e){
        if(e.checked == true){
            localStorage.setItem("autoRefresh",true)
            this.autoRefreshInterval = setInterval(this.pageReload, 120000); // <- time in ms
            this.setState({checked:e.checked});
        } else {
            localStorage.setItem("autoRefresh",false)
            clearInterval(this.autoRefreshInterval);
            this.setState({checked:e.checked});
        }
        
    }

    render() {
        

        //dashboard authorization
        let getHolidayAccess = false;
        let getLeaveChartAccess = false;
        let getNewsAccess = false;
        let getRecruitmentAccess = false;
        let getRequestsAccess = false;
        let getTeamAccess = false;
        let getVideoAccess = false;
        let getOperationRequestsAccess = false;
        let getAttendanceChartAccess = false;
        let getCalendarAccess = false;
        let getWcaStatisticsAccess = false;
        let getSafetyControllerListAccess = false;
        let getAcceptorListAccess = false;
        let getHeadCountChrtAccess = false;
        let getLeaveHeadCountChrtAccess = false;        

        if(this.getHolidayAccess !== undefined){
            getHolidayAccess = (this.getHolidayAccess.viewAccess === true) ? true : false;
        }

        if(this.getLeaveChartAccess !== undefined){
            getLeaveChartAccess = (this.getLeaveChartAccess.viewAccess === true) ? true : false;
        }

        if(this.getNewsAccess !== undefined){
            getNewsAccess = (this.getNewsAccess.viewAccess === true) ? true : false;
        }

        // if(this.getRecruitmentAccess !== undefined){
        //     getRecruitmentAccess = (this.getRecruitmentAccess.viewAccess === true) ? true : false;
        // }

        if(this.getRequestsAccess !== undefined){
            getRequestsAccess = (this.getRequestsAccess.viewAccess === true) ? true : false;
        }

        if(this.getTeamAccess !== undefined){
            getTeamAccess = (this.getTeamAccess.viewAccess === true) ? true : false;
        }

        if(this.getVideoAccess !== undefined){
            getVideoAccess = (this.getVideoAccess.viewAccess === true) ? true : false;
        }

        if(this.getOperationRequestsAccess !== undefined){
            getOperationRequestsAccess = (this.getOperationRequestsAccess.viewAccess === true) ? true : false;
        }

        if(this.getAttendanceChartAccess !== undefined){
            getAttendanceChartAccess = (this.getAttendanceChartAccess.viewAccess === true) ? true : false;
        }

        if(this.getCalendarAccess !== undefined){
            getCalendarAccess = (this.getCalendarAccess.viewAccess === true) ? true : false;
        }

        if(this.getWcaStatisticsAccess !== undefined){
            getWcaStatisticsAccess = (this.getWcaStatisticsAccess.viewAccess === true) ? true : false;
        }

        if(this.getSafetyControllerListAccess !== undefined){
            getSafetyControllerListAccess = (this.getSafetyControllerListAccess.viewAccess === true) ? true : false;
        }

        if(this.getAcceptorListAccess !== undefined){
            getAcceptorListAccess = (this.getAcceptorListAccess.viewAccess === true) ? true : false;
        }

        if(this.getHeadCountChrtAccess !== undefined){
            getHeadCountChrtAccess = (this.getHeadCountChrtAccess.viewAccess === true) ? true : false;
        }
        if(this.getLeaveHeadCountChrtAccess !== undefined){
            getLeaveHeadCountChrtAccess = (this.getLeaveHeadCountChrtAccess.viewAccess === true) ? true : false;
        }
        const { requestListData, calendarData} = this.props;
        
        let showteamMembers = false;
        if(requestListData[4] !== undefined){
            if(requestListData[4].length > 0){
                showteamMembers = true;// to show the dropdown on top of the calendar
            }
        }
        

        //headcount chart 
        let headCountChartData = [];
        let LeaveheadCountChartData = [];        
        let totalNoOfPplInCompany = requestListData[7] && requestListData[7].find(el => el.status == 'ALL').headcount || 0;
        let numberOfPplInPremise = requestListData[7] && requestListData[7].find(el => el.status == 'IN').headcount || 0; 
        let numberOfPplNotInCompany = (totalNoOfPplInCompany - numberOfPplInPremise  >= 0) ? (totalNoOfPplInCompany - numberOfPplInPremise) : 0; //calculation to avoid negative numbers

        let totalNoOfPplInAnnualLeave = requestListData[7] && requestListData[7].find(el => el.status == 'ALL').headcount || 0;
        let numberOfPplInSickLeave = requestListData[7] && requestListData[7].find(el => el.status == 'IN').headcount || 0;         
        
        headCountChartData.push(numberOfPplInPremise, numberOfPplNotInCompany);
        const headCountChart = {
            labels: ['On Premise', 'Off Premise'],
            datasets: [
                {
                    data: headCountChartData,
                    backgroundColor: [
                        "#0b9e79",
                        "#e3483d"
                    ],
                    hoverBackgroundColor: [
                        "#0b9e79",
                        "#e3483d"
                    ]
                }]
        }

        LeaveheadCountChartData.push(totalNoOfPplInAnnualLeave, numberOfPplInSickLeave);
        //password popup
        let passwordPopUpHtml = '';
        if (this.state.passwordPopUp && this.props.successs == null) {
            passwordPopUpHtml = <ChangePassword changePassword={this.changePassword} password={this.state.password} clearPassword={this.clearPassword} confirmPassword={this.state.confirmPassword} change={this.change} />
        }

        //leave days chart 
        let allocateDaysValues = requestListData[3] && requestListData[3].reduce((a, el) => {
            a.push(el.allocateD_DAYS);
            return a;
        }, []) || []//getting the number of allocated days from props

        let leaveTypes = requestListData[3] && requestListData[3].reduce((a, el) => {
            a.push(el.name);
            return a;
        }, []) || [] //getting all allocated leave type from props

        let balanceDaysValues = requestListData[3] && requestListData[3].reduce((a, el) => {
            a.push(el.balancE_DAYS);
            return a;
        }, []) || []//getting the number of balance days of the allocated leave days from props

        const barData = {
            labels: leaveTypes,
            datasets: [
                {
                    label: 'Allocated Leave',
                    backgroundColor: '#42A5F5',
                    data: allocateDaysValues
                },
                {
                    label: 'Balance Leave',
                    backgroundColor: '#AB47BC',
                    data: balanceDaysValues
                }
            ]
        }


        let processEvents = calendarData && calendarData.length > 0 ? calendarData : [
            {
                "employeeIdu": "7fb57592-f56c-406c-b48d-bc509ffc4696",
                "scheduleDate": "11/1/2020 12:00:00 AM",
                "shiftCodeId": "26",
                "shiftId": "NS"
            },
            {
                "employeeIdu": "7fb57592-f56c-406c-b48d-bc509ffc4696",
                "scheduleDate": "11/1/2020 07:30:00 PM",
                "shiftCodeId": "26",
                "shiftId": "NS"
            }
        ];

        let teamMembers = requestListData[4] && requestListData[4].map((member) => {
            return{
                label:member.name,
                value:member.employeE_ID,
            }
        }) || []
      
        teamMembers.push({
            label: 'Self - ' + this.props.loggedUserDetail.EmployeeName ,
            value:this.props.loggedUserDetail.empID
        })

        
        let Jobreq = this.props.requestListData[12] && this.props.requestListData[12].map((jobr) => {
            return{
                label:jobr.requestNum,
                value:jobr.requestID,
            }
        }) || []  

        const events = processEvents && processEvents.map(el => Object.assign({}, { title: el.attnTime, start: moment(el.attnDate).format('YYYY-MM-DD'), end: moment(el.attnDate).format('YYYY-MM-DD') }, { ...el })) || [];

        //Acceptor List and Safety Controller List Table
        let wpCertificateDetails = (this.props.wpCertificateDetails.length > 0) ? this.props.wpCertificateDetails : [];
        let safetyContollersList = wpCertificateDetails.filter(el => el.docDocumentType === "SafetyController").map(el => {
            return{
                "empNo": el.employeeNo,
                "empName": el.employeeName,
                "expiryDate": moment(el.docExpiryDate).format('MM/DD/YYYY'),
            }
        }); 
        let acceptorsList = wpCertificateDetails.filter(el => el.docDocumentType === "Acceptor").map(el => {
            return{
                "empNo": el.employeeNo,
                "empName": el.employeeName,
                "expiryDate": moment(el.docExpiryDate).format('MM/DD/YYYY'),
            }
        }); 

        //Safety Requests Chart
        let safetyStatisticData = requestListData[9] && requestListData[9] || [];
        let safetyStatusList =  requestListData[9] && requestListData[9].reduce((a, el) => {
            a.push(el.status);
            return a;
        }, []) || [] //getting the different of statuses from props

        let safetyReqCount =  requestListData[9] && requestListData[9].reduce((a, el) => {
            a.push(el.count);
            return a;
        }, []) || [] //getting the count of corresponding statuses

        let safetyChartData = {
            labels: safetyStatusList,
            datasets: [
                {
                    data: safetyReqCount,
                    backgroundColor: [
                        "#42A5F5",
                        "#66BB6A",
                        "#FFA726",
                        "#0b9e79",
                        "#e3483d",
                        '#AB47BC'
                    ],
                    hoverBackgroundColor: [
                        "#64B5F6",
                        "#81C784",
                        "#FFB74D",
                        "#0b9e79",
                        "#e3483d",
                        '#AB47BC'
                    ]
                }
            ]
        };
        // head count display calculation start
        let headCountData = (requestListData[10] && requestListData[10].length > 0 ) ? requestListData[10] : [];
        let LadiesOfficeHc= (headCountData && headCountData.length > 0  && headCountData.find(el =>el.status == "Ladies Office HeadCount")) ? headCountData.find(el =>el.status == "Ladies Office HeadCount") : {count: 0};
        let to5Hc = (headCountData && headCountData.length > 0  &&  headCountData.find(el => el.status == "Time Office 5 HeadCount")) ? headCountData.find(el => el.status == "Time Office 5 HeadCount") : {count: 0};
        let to8Hc = (headCountData && headCountData.length > 0  && headCountData.find(el => el.status == "Time Office 8 HeadCount")) ? headCountData.find(el => el.status == "Time Office 8 HeadCount") : {count: 0};
        let to10HC = (headCountData && headCountData.length > 0  && headCountData.find(el => el.status == "Time Office 10 HeadCount")) ? headCountData.find(el => el.status == "Time Office 10 HeadCount") : {count: 0};
        let siteHc = (headCountData && headCountData.length > 0  && headCountData.find(el => el.status == "Site Office HeadCount")) ? headCountData.find(el => el.status == "Site Office HeadCount") : {count: 0};
        let missingHc = (headCountData && headCountData.length > 0  && headCountData.find(el => el.status == "Missing Head Count - Safety Drill")) ? headCountData.find(el => el.status == "Missing Head Count - Safety Drill") : {count: 0};
        // head count display calculation end

        let AnnualLeaveHC= (headCountData && headCountData.length > 0  && headCountData.find(el =>el.status == "Annual Leave")) ? headCountData.find(el =>el.status == "Annual Leave") : {count: 0};
        let SickLeaveHC = (headCountData && headCountData.length > 0  &&  headCountData.find(el => el.status == "Sick leave 100% Paid")) ? headCountData.find(el => el.status == "Sick leave 100% Paid") : {count: 0};
        //head count table header
        const headerHCTable = (
            <div className="p-grid p-justify-between">
                <div className="p-col-2">
                <Button type="button" icon="pi pi-external-link" iconPos="left" label="Export List" onClick={this.exportCSV} style={{backgroundColor:'#406882'}}></Button>
                </div>
                <div className="p-col-5">
                <InputText type="search" onInput={e => {this.setState({hCTableFilter: e.target.value })}} placeholder="Search..." />
                </div>
            </div>
        )     
        //operation data processing
        let operationData = (requestListData[8]) ?  requestListData[8].map(function(elem) {
            return {
              ...elem,
              "requestDate":moment(elem.requestDate).format('MM/DD/YYYY'),
            } 
          }) : [];

        requestListData[0] = (requestListData[0]) ? requestListData[0].map(function (elem) {
            const m1 = elem && elem.requestDate ? moment(elem.requestDate) : null;
            const m2 = elem && elem.fromDate ? moment(elem.fromDate) : null;
            const m3 = elem && elem.toDate ? moment(elem.toDate) : null;
            let d1 = m1 && m1.isValid() ? m1.format('MM/DD/YYYY') : '';
            let d2 = m2 && m2.isValid() ? m2.format('MM/DD/YYYY') : '';
            let d3 = m3 && m3.isValid() ? m3.format('MM/DD/YYYY') : '';
            return {
              ...elem,
                "requestDate": elem.requestDate && d1,
                "fromDate": elem.fromDate && d2,
                "toDate": elem.toDate && d3,

            } 
          }) : [];

      
        return (
            <div className="p-grid p-fluid dashboard">
                {(this.props.loading || this.state.loading) && <div className="page-loader"></div>}
                {this.props.error !== null && <Messages type="error" message={this.props.error} />}
                {this.props.success !== null && <Messages type="success" message={this.props.success} />}
                <Toast ref={(el) => this.growl = el} />
                {passwordPopUpHtml}
                {/* {(this.getVideoAccess !== undefined && this.getVideoAccess.viewAccess !== false) &&
                    <div className="p-col-12 p-lg-6 animated fadeIn ">
                        <div className="card card-w-title">
                            <h1>Feature Videos</h1>
                            {(this.props.companyData && this.props.companyData.company !== undefined) &&
                                <FeatureVideo companyDetails={this.props.companyData.company} />
                            }
                        </div>
                    </div>
                } */}

                {getAttendanceChartAccess &&
                    <div className="p-col-12 p-lg-6 animated fadeIn ">
                        <div className="card card-w-title ">
                            <h1>Attendance Status - As of now</h1>
                            <Chart type="doughnut" data={headCountChart} />
                        </div>
                    </div>
                } 

                {(getNewsAccess !== undefined && getNewsAccess !== false) &&
                    <div className="p-col-12 p-lg-6 animated fadeIn ">
                        <div className="card card-w-title ">
                            <h1>Announcements &amp; Updates</h1>
                            <NewsFeeds data={requestListData[5] || []} />
                            {/* <div className="p-col-4 p-offset-8" style={{ marginTop: '20px' }}>
                                <Button label="More" className="p-button-primary p-button-rounded" />
                            </div> */}
                        </div>
                    </div>
                }
                
                {(getWcaStatisticsAccess !== undefined && getWcaStatisticsAccess !== false) &&
                    <div className="p-col-12 p-lg-6 animated fadeIn ">
                        <div className="card card-w-title ">
                            <h1>WCA Status Statistics</h1>
                            <DataTable
                            value={safetyStatisticData}
                            responsive
                            className="p-datatable-customers animated fadeIn"
                            rowHover
                            paginator
                            rows={8}
                            emptyMessage="No lists found"  >
                            {/* <Column field="slNo" sortable={true} header="Serial No." /> */}
                            <Column field="status" sortable={true} header="Permit Description" />
                            <Column field="count" sortable={true} header="Number Of" />
                        </DataTable>
                        </div>
                    </div>
                }
                
                {/* { (getHeadCountChrtAccess !== undefined && getHeadCountChrtAccess !== false) &&
                    <div className="p-col-12 p-lg1-12 animated fadeIn " >
                    <div className="card " style={{textAlign: 'center'}}>
                    <h1>Head Count</h1>
                        <div className="p-grid p-justify-even">

                        <div className="p-col-12 p-md-6 p-lg-2 p-sm-12  animated bounceIn ">
                        <Card 
                            style={{textAlign: 'center', }} 
                            header={<div style={{backgroundColor:'#406882', textAlign: 'center', padding:'1px', color:'#F6F6F6', minHeight: '80px'}}><h3>Ladies Office HeadCount</h3></div>}
                            footer = {this.headCountFooter('Ladies Office HeadCount')}
                            >
                            <span style={{ backgroundColor: 'F9F3F3', padding:'1px' , fontSize: '55px'}}>{LadiesOfficeHc.count}</span>
                        </Card>
                        </div> 

                        <div className="p-col-12 p-md-6 p-lg-2 p-sm-12  animated bounceIn ">
                        <Card 
                            style={{textAlign: 'center',}} 
                            header={<div style={{backgroundColor:'#406882', textAlign: 'center', padding:'1px', color:'#F6F6F6', minHeight: '80px'}}><h3>Time Office 5 HeadCount</h3></div>}
                            footer = {this.headCountFooter('Time Office 5 HeadCount')}
                            >
                            <span style={{ backgroundColor: 'F9F3F3', padding:'1px' , fontSize: '55px'}}>{to5Hc.count}</span>
                        </Card>
                        </div> 

                        <div className="p-col-12 p-md-6 p-lg-2 p-sm-12  animated bounceIn ">
                        <Card 
                            style={{ textAlign: 'center',}} 
                            header={<div style={{backgroundColor:'#406882', textAlign: 'center', padding:'1px', color:'#F6F6F6',minHeight: '80px'}}><h3>Time Office 8 HeadCount </h3></div>}
                            footer = {this.headCountFooter('Time Office 8 HeadCount')}
                            >
                            <span style={{ backgroundColor: 'F9F3F3', color:'#20d077', padding:'1px' , fontSize: '55px'}}>{to8Hc.count}</span>
                        </Card>
                        </div> 

                        {(to5Hc.count > 0 || to10HC.count > 0 ||  siteHc.count > 0) && 
                        <div className="p-col-12 p-md-6 p-lg-2 p-sm-12  animated bounceIn ">
                            <Card 
                                style={{textAlign: 'center',}} 
                                header={<div style={{backgroundColor:'#406882', textAlign: 'center', padding:'1px', color:'#F6F6F6', minHeight: '80px'}}><h3>Time Office 10 HeadCount</h3></div>}
                                footer = {this.headCountFooter('Time Office 10 HeadCount')}
                                >
                                <span style={{color: '#CC3333', backgroundColor: 'F9F3F3', padding:'1px' , fontSize: '55px'}}>{to10HC.count}</span>
                            </Card>
                        </div> 
                        }

                        <div className="p-col-12 p-md-6 p-lg-2 p-sm-12  animated bounceIn ">
                        <Card 
                            style={{textAlign: 'center',}} 
                            header={<div style={{backgroundColor:'#406882', textAlign: 'center', padding:'1px', color:'#F6F6F6', minHeight: '80px'}}><h3>Site Office HeadCount</h3></div>}
                            footer = {this.headCountFooter('Site Office HeadCount')}
                            >
                            <span style={{ backgroundColor: 'F9F3F3', padding:'1px' , fontSize: '55px'}}>{siteHc.count}</span>
                        </Card>
                        </div>                         

                        <div className="p-col-12 p-md-6 p-lg-2 p-sm-12  animated bounceIn ">
                        <Card 
                            style={{textAlign: 'center',}} 
                            header={<div style={{backgroundColor:'#406882', textAlign: 'center', padding:'1px', color:'#F6F6F6', minHeight: '80px'}}><h3>Missing Head Count - Safety Drill</h3></div>}
                            footer = {this.headCountFooter('Missing Head Count - Safety Drill')}
                            >
                            <span style={{ backgroundColor: 'F9F3F3', padding:'1px' , fontSize: '55px'}}>{missingHc.count}</span>
                        </Card>
                        </div> 

                        </div> 

                        </div>
                    </div>
                }

                { (getLeaveHeadCountChrtAccess !== undefined && getLeaveHeadCountChrtAccess !== false) &&
                    <div className="p-col-12 p-lg1-12 animated fadeIn " >
                        <div className="card " style={{textAlign: 'center'}}>
                        <h1>Leave Statistics - Live</h1>
                            <div className="p-grid p-justify-even">

                            <div className="p-col-12 p-md-6 p-lg-2 p-sm-12  animated bounceIn ">
                            <Card 
                                style={{textAlign: 'center', }} 
                                header={<div style={{backgroundColor:'#406882', textAlign: 'center', padding:'1px', color:'#F6F6F6', minHeight: '80px'}}><h3>Annual Leave</h3></div>}
                                footer = {this.LeaveheadCountFooter('Annual Leave')}
                                >
                                <span style={{ backgroundColor: 'F9F3F3', padding:'1px' , fontSize: '55px'}}>{AnnualLeaveHC.count}</span>
                            </Card>
                            </div> 

                            <div className="p-col-12 p-md-6 p-lg-2 p-sm-12  animated bounceIn ">
                            <Card 
                                style={{textAlign: 'center',}} 
                                header={<div style={{backgroundColor:'#406882', textAlign: 'center', padding:'1px', color:'#F6F6F6', minHeight: '80px'}}><h3>Sick leave 100% Paid</h3></div>}
                                footer = {this.LeaveheadCountFooter('Sick leave 100% Paid')}
                                >
                                <span style={{ backgroundColor: 'F9F3F3', padding:'1px' , fontSize: '55px'}}>{SickLeaveHC.count}</span>
                            </Card>
                            </div> 

                            </div> 

                            </div>
                        </div>
                } */}


                {(getOperationRequestsAccess !== undefined && getOperationRequestsAccess !== false) &&
                <div className="p-col-12 p-lg1-12 animated fadeIn ">
                        <div className="card">
                            <div className="p-grid">
                                <div className="p-md-11 p-justify-start">
                                    <h1>Operation Requests</h1>
                                </div>
                                <div className="p-md-1 ">
                                    <div className="p-field-checkbox">
                                        <Checkbox inputId="binary" checked={this.state.checked} onChange={e => {this.handleAutoRefresh(e)}} />
                                        <label htmlFor="binary">{this.state.checked ? 'Auto Refresh ON' : 'Auto Refresh OFF'}</label>
                                    </div>
                                </div>
                            </div>
                            <OperationRequest
                                requestRedirect={this.requestRedirect}
                                data={operationData}
                                activeIndex={this.state.activeIndex}
                                requestInvolved={requestListData[10] || []}
                                onHCChanged ={e => {this.setState({onHCChanged: e.target.value })}} // headerCreated onHCChanged 
                                onHPChanged ={e => {this.setState({onHPChanged: e.target.value })}} // headerPrepared onHPChanged 
                                onHAChanged ={e => {this.setState({onHAChanged: e.target.value })}} // headerAccepted onHAChanged 
                                onHIChanged ={e => {this.setState({onHIChanged: e.target.value })}} // headerIssued onHIChanged 
                                onHRSChanged ={e => {this.setState({onHRSChanged: e.target.value })}} // headerRequestedToSurrender onHRSChanged 
                                onHRChanged ={e => {this.setState({onHRChanged: e.target.value })}} // headerSurrender onHRChanged 
                                onHRRChanged ={e => {this.setState({onHRRChanged: e.target.value })}} // headerReissueRequested onHRRChanged 
                                onHReChanged ={e => {this.setState({onHReChanged: e.target.value })}} // headerReissued onHReChanged 
                                onHRFCSChanged ={e => {this.setState({onHRFCSChanged: e.target.value })}} // headerRequestsForClearOrSurrender onHRFCSChanged 
                                onHPlChanged ={e => {this.setState({onHPlChanged: e.target.value })}} // headerPlanned onHPlChanged 
                                onHCaChanged ={e => {this.setState({onHCaChanged: e.target.value })}} // headerCancellation onHCaChanged 
                                onHRRIChanged ={e => {this.setState({onHRRIChanged: e.target.value })}} // requeset involved 

                                OnHCChanged={this.state.onHCChanged} // headerCreated onHCChanged
                                OnHPChanged={this.state.onHPChanged} // headerPrepared onHPChanged
                                OnHAChanged={this.state.onHAChanged} // headerAccepted onHAChanged
                                OnHIChanged={this.state.onHIChanged} // headerIssued onHIChanged
                                OnHRSChanged={this.state.onHRSChanged} // headerRequestedToSurrender onHRSChanged
                                OnHRChanged={this.state.onHRChanged} // headerSurrender onHRChanged
                                OnHRRChanged={this.state.onHRRChanged} // headerReissueRequested onHRRChanged
                                OnHReChanged={this.state.onHReChanged} // headerReissued onHReChanged
                                OnHRFCSChanged={this.state.onHRFCSChanged} // headerRequestsForClearOrSurrender onHRFCSChanged
                                OnHPlChanged={this.state.onHPlChanged} // headerPlanned onHPlChanged
                                OnHCaChanged={this.state.onHCaChanged} // headerCancellation onHCaChanged
                                OnHRRIChanged={this.state.onHRRIChanged} // requeset involved 
                                /> 
                        </div>
                    </div>
                }

               {(getRequestsAccess !== undefined && getRequestsAccess !== false) &&
                    <>
                        
              
                        <div className="p-col-12 p-lg1-12 animated fadeIn ">
                            <div className="card">
                                <h1>Recent Requests</h1>
                                <RequestLeave
                                    requestRedirect={this.requestRedirect}
                                    data={requestListData[0] || []}
                                    cars={this.state.cars}
                                    requestLeave={requestListData[0] || []}
                                    pendingApproval={requestListData[0] || []}
                                    requestInvolved={requestListData[0] || []}
                                    selectedCar={this.state.selectedCar}
                                    activeIndex={this.state.activeIndex}
                                    actionsPending={requestListData[6] || []}
                                    selectedApproval={this.state.selectedApproval}
                                    onSearchChangeY={e => this.setState({globalFilterY: e.target.value })}
                                    onSearchChangeP={e => this.setState({globalFilterP: e.target.value })}
                                    onSearchChangeA={e => this.setState({globalFilterA: e.target.value })}
                                    onSearchChangeR={e => this.setState({globalFilterR: e.target.value })}
                                    globalFilterY={this.state.globalFilterY}
                                    globalFilterP={this.state.globalFilterP}
                                    globalFilterA={this.state.globalFilterA}
                                    globalFilterR={this.state.globalFilterR}
                                    onApprovalChange={e => this.setState({ selectedApproval: e.value })}
                                    handleApprove={this.handleApprove.bind(this)}
                                    approveRejectDisabled={this.state.approveRejectDisabled}
                                />
                            </div>
                        </div>
                    </>
                }

                     {(getRecruitmentAccess !== undefined && getRecruitmentAccess !== false) &&
                    <>
    
                        <div className="p-col-12 p-lg1-12 animated fadeIn ">
                            <div className="card">
                                <h1>Recruitment</h1>
                                <div className="p-grid">
                                    <div className="p-col-12 p-lg-12">
                                        <h2><label className="label">Select Job Requisition<span className="requiredColor">*</span></label></h2>
                                        <div className="mt1">
                                            <Dropdown placeholder="Select Job Requisition" name="JobRequisition" value={this.state.jobreqd} options={Jobreq} onChange={(e) => this.setState({jobreqd:e.target.value})}    style={{ width: '100%' }}/>
                                        </div> 
                                    </div>   
                                </div>



                                <Recruitment
                                    requestRedirect={this.requestRedirect}
                                    data={requestListData[13] || []}
                                    cars={this.state.cars}
                                    requestLeave={requestListData[13] || []}
                                    pendingApproval={requestListData[13] || []}
                                    requestInvolved={requestListData[13] || []}
                                    selectedCar={this.state.selectedCar}
                                    activeIndex={this.state.activeIndex}
                                    actionsPending={requestListData[6] || []}
                                    selectedApproval={this.state.selectedApproval}
                                    onSearchChangeY={e => this.setState({globalFilterY: e.target.value })}
                                    onSearchChangeP={e => this.setState({globalFilterP: e.target.value })}
                                    onSearchChangeA={e => this.setState({globalFilterA: e.target.value })}
                                    onSearchChangeR={e => this.setState({globalFilterR: e.target.value })}
                                    globalFilterY={this.state.globalFilterY}
                                    globalFilterP={this.state.globalFilterP}
                                    globalFilterA={this.state.globalFilterA}
                                    globalFilterR={this.state.globalFilterR}
                                    onApprovalChange={e => this.setState({ selectedApproval: e.value })}
                                    handleApprove={this.handleApprove.bind(this)} />
                            </div>
                        </div>
                    </>
                }             

                {(getSafetyControllerListAccess !== undefined && getSafetyControllerListAccess !== false) &&
                    <div className="p-col-12 p-lg-6 animated fadeIn ">
                        <div className="card card-w-title ">
                            <h1>List Of Safety Controllers</h1>
                            <DataTable
                            value={safetyContollersList}
                            responsive
                            className="p-datatable-customers animated fadeIn"
                            rowHover
                            paginator
                            rows={8}
                            emptyMessage="No lists found"  >
                            <Column field="empNo" sortable={true} header="Employee Number" />
                            <Column field="empName" sortable={true} header="Employee Name"  />
                            <Column field="expiryDate" sortable={true} header="Date Of Expiry (MM/DD/YYYY)" />
                        </DataTable>
                        </div>
                    </div>
                }

                {(getAcceptorListAccess !== undefined && getAcceptorListAccess !== false) &&
                    <div className="p-col-12 p-lg-6 animated fadeIn ">
                        <div className="card card-w-title ">
                            <h1>List Of Acceptors</h1>
                            <DataTable
                            value={acceptorsList}
                            responsive
                            className="p-datatable-customers animated fadeIn"
                            rowHover
                            paginator
                            rows={8}
                            emptyMessage="No lists found"  >
                            <Column field="empNo" sortable={true} header="Employee Number" />
                            <Column field="empName" sortable={true} header="Employee Name"  />
                            <Column field="expiryDate" sortable={true} header="Date Of Expiry (MM/DD/YYYY)" />
                        </DataTable>
                        </div>
                    </div>
                }
                
                {(this.state.showteamMembers) &&
                    <div className="p-col-12 p-lg-6  animated fadeIn">
                        <div className="card card-w-title">
                            <h1>My Teams</h1>

                            <ScrollPanel style={{ width: '100%', height: '300px' }}>
                                <Teams data={requestListData[4] || []} />
                            </ScrollPanel>
                        </div>
                    </div>
                }

                {(getHolidayAccess !== undefined && getHolidayAccess !== false) &&
                    <div className="p-col-12 p-lg-6  animated fadeIn">
                        <div className="card card-w-title">
                            <h1>Holidays</h1>
                            <ScrollPanel style={{ width: '100%', height: '300px' }}>
                                <Holidays data={requestListData[2] || []} />
                            </ScrollPanel>
                        </div>
                    </div>
                }

                {(getLeaveChartAccess !== undefined && getLeaveChartAccess !== false) &&
                    <div className="p-col-12 p-lg1-12  animated fadeIn">
                        <div className="card card-w-title">
                            <h1>Leave Quota (till end of the year (EOY))</h1>
                            <Chart type="bar" data={barData} />
                            
                        </div>
                    </div>
                }

                {(getWcaStatisticsAccess !== undefined && getWcaStatisticsAccess !== false) && 
                    <div className="p-col-12 p-lg1-12  animated fadeIn">
                        <div className="card card-w-title">
                            <h1>WCA Chart</h1>
                            <Chart type="pie" data={safetyChartData} />
                            
                        </div>
                    </div>
                } 

                {/* {(getCalendarAccess !== undefined && getCalendarAccess !== false) &&
                    <div className="p-col-12 p-lg1-12  animated fadeIn">
                        <div id='MyCalendar' className="card card-w-title">
                            <h1>Calendar</h1> 

                            {(showteamMembers) &&
                            <div>
                                <label >Show Calendar For</label>
                                <div className="mt1">
                                <Dropdown placeholder="Show Calendar For" name="viewCalendarFor"  value={this.state.viewCalendarFor} options={teamMembers} onChange={event => this.handleCalendarChange(event)} {...DROPDOWN_CONFIG} style={{ width: '100%' }} />  
                                </div>
                            </div>
                            }
                            
                            <FullCalendar
                            id="My_calendar"
                            ref={this.calendarRef}
                            events={events}
                            options={this.state.options}
                            eventPropGetter={event => {
                                const eventData = this.state.options.find(ot => ot.id === event.id);
                                const backgroundColor = eventData && eventData.color;
                                return { style: { backgroundColor } };
                            }} />
                        </div>
                    </div>
                }

                <Dialog header="Head Count List" visible={this.state.hCEmpDislay} style={{ width: '60vw' }} onHide={() => this.setState({hCEmpDislay:false, hCTableData:[], hCTableFilter:null})}>
                    <DataTable
                        header={headerHCTable}
                        value={this.state.hCTableData}
                        responsive
                        className="p-datatable-customers animated fadeIn"
                        rowHover
                        paginator
                        rows={20}
                        exportFilename={"Head Count List"}
                        ref={(el) => { this.dt = el; }}
                        globalFilter ={this.state.hCTableFilter}
                        emptyMessage="No One Found"  >
                        <Column field="psnno" sortable={true} header="Employee Number" />
                        <Column field="psnname" sortable={true} header="Employee Name"  />
                    </DataTable>
                </Dialog>

                <Dialog header={this.state.HCText}    visible={this.state.hCEmpDislay} style={{ width: '60vw' }} onHide={() => this.setState({hCEmpDislay:false, hCTableData:[], hCTableFilter:null})}>
                    <DataTable
                        header={headerHCTable}
                        value={this.state.hCTableData}
                        responsive
                        className="p-datatable-customers animated fadeIn"
                        rowHover
                        paginator
                        rows={20}
                        exportFilename={"Leave Count List"}
                        ref={(el) => { this.dt = el; }}
                        globalFilter ={this.state.hCTableFilter}
                        emptyMessage="No One Found"  >
                        <Column field="psnno" sortable={true} header="Employee Number" />
                        <Column field="psnname" sortable={true} header="Employee Name"  />
                        <Column field="department" sortable={true} header="Department"  />                        
                    </DataTable>
                </Dialog>                 */}

            </div>
        );
    }
}



const mapStateToProps = state => {
    return {
        loggedUserDetail: state.auth.userObject,
        loading: state.master.loading,
        error: state.master.error,
        success: state.master.success,
        loginUserDetail: state.auth.userDetail,
        wpCertificateDetails: state.master.tableLists,
        requestListData: state.master.requestListData,
        calendarData: state.master.calendarData
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getMasterTableList: (table) => dispatch(actions.getMasterTableList(table)),
        processDynamicData: (model, type, data, func) => dispatch(actions.processDynamicData(model, type, data, func)),
        getRequest: (value) => dispatch(actions.getRequest(value)),
        getCalendarData: (empId, model, fromDate, toDate) => dispatch(actions.getCalendarData(empId, model, fromDate, toDate))
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);